<template>
    <div>
        <div
            class="info_content"
            :class="{
            fully_paid: paymentProgress.statusOptions.isFullyPaid(itemDetail.payStatus),
            is_partially_paid: paymentProgress.statusOptions.isPartiallyPaid(itemDetail.payStatus),
            no_payments: paymentProgress.statusOptions.isUnpaid(itemDetail.payStatus),
            revoked: paymentProgress.statusOptions.isRevoked(itemDetail.payStatus),
            pointer: itemDetail.id !== 1
        }"
            @click="showInfo()"
        >
            <template>
                <template v-if="itemDetail.id === 1">
                    <div class="flex flex_between content_item font_bold">{{info.closingFeePaymentDate}}</div>
                    <div class="flex flex_between content_item">
                        <span>{{info.closingFeeAmount}}</span>
                        <span class="font_bold">{{itemDetail.paidText}}</span>
                    </div>
                </template>
                <template v-if="itemDetail.id !== 1 && listItemInfo && listItemInfo.id">
                    <div class="flex flex_between content_item font_bold">
                        <span>{{listItemInfo.paymentDate}}</span>
                        <i v-if="!confirmed" class="fa fa-clock"></i>
                    </div>
                    <div class="flex flex_between content_item">
                        <span>{{listItemInfo.paidAmount}}</span>
                        <span class="font_bold">{{itemDetail.paidText}}</span>
                    </div>
                    <div class="content_item">
                        <div v-show="listItemInfo.show" class="pay_info">
                            <div class="flex flex_between info_center">
                                <div>
                                    <p class="font_bold">{{$t("PayImgInfo.Sender")}}</p>
                                    <p class="info_sender_name">{{listItemInfo.sender}}</p>
                                    <div class="info_sender_account">
                                        <p>{{listItemInfo.fromIban || ""}}</p>
                                        <p>{{listItemInfo.fromBic || ""}}</p>
                                    </div>
                                </div>
                                <div class="info_arrow">
                                    <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                                </div>
                                <div>
                                    <p class="font_bold">{{$t("PayImgInfo.Receiver")}}</p>
                                    <p class="info_receiver_name">{{listItemInfo.receiver}}</p>
                                    <div class="info_receiver_account">
                                        <p>{{listItemInfo.toIban || ""}}</p>
                                        <p>{{listItemInfo.toBic || ""}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex_between">
                            <span></span>
                            <i
                                aria-hidden="true"
                                class="font_lg fa caret_icon"
                                :class="listItemInfo.show ? 'fa-caret-up' : 'fa-caret-down'"
                            ></i>
                        </div>
                    </div>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import {formatAsLocalizedDate, formatAsMoneyAmount} from "@/common/format";
import {paymentProgress} from "@/common/utils/paymentProgress";

export default {
    props: {
        info: Object,
        itemDetail: Object,
        listItem: Object,
        confirmed: { type: Boolean, default: true }
    },
    data() {
        return {
        	paymentProgress: paymentProgress,
            listItemInfo: { show: false }
        };
    },
    beforeMount() {
        if (this.listItem) {
            this.listItemInfo = {
                ...this.listItemInfo,
                ...this.listItem,
                paidAmount: formatAsMoneyAmount(this.listItem.paidAmount, { currency: this.listItem.currency }),
                paymentDate: formatAsLocalizedDate(this.listItem.paymentDate)
            };
        }
    },
    methods: {
        showInfo() {
            this.listItemInfo.show = !this.listItemInfo.show;

            if (this.listItemInfo.show) {
                this.itemDetail.showCount++;
            } else {
                this.itemDetail.showCount--;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "src/components/templates/investor/payments/receivables/investorReceivablePayments";
</style>